(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('ZoneController', ZoneController);

    ZoneController.$inject = ['$scope','msgdata','$uibModalInstance','MessageService','Provinces','$q', 'LocationProvice'];

    function ZoneController ($scope,msgdata,$uibModalInstance,MessageService,Provinces,$q, LocationProvice) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.areas =[];

        loadData();
        function loadData() {
            // Provinces.getAll({},function(res){
            //     vm.areas = res;
            //     $q.all([vm.areas.$promise]).then(function(){
            //         if(msgdata == null || msgdata.length ==0){
            //             angular.forEach(vm.areas,function(item){
            //                 item.selected = false;
            //                 angular.forEach(item.provinces,function(value){
            //                     value.selected = false;
            //                 })
            //             })
            //         }else{
            //             angular.forEach(vm.areas,function(item){
            //                 angular.forEach(msgdata,function(value){
            //                     if(item.area == value.area && item.provinces.length == value.provinces.length){
            //                         item.selected = true;
            //                     }
            //                     angular.forEach(item.provinces,function(item1){
            //                         angular.forEach(value.provinces,function(value2){
            //                             if(item1.name == value2.name){
            //                                 item1.selected = true;
            //                             }
            //                         })
            //                     })
            //                 })
            //             });
            //             console.log(vm.areas)
            //         }
            //     })
            // });

            LocationProvice.query({},function (data) {
                vm.areas = arrInit(data);
                $q.all([vm.areas.$promise]).then(function(){
                    if(msgdata == null || msgdata.length ==0){
                        angular.forEach(vm.areas,function(item){
                            item.selected = false;
                            angular.forEach(item.provinces,function(value){
                                value.selected = false;
                            })
                        })
                    }else{
                        angular.forEach(vm.areas,function(item){
                            angular.forEach(msgdata,function(value){
                                if(item.area == value.area && item.provinces.length == value.provinces.length){
                                    item.selected = true;
                                }
                                angular.forEach(item.provinces,function(item1){
                                    angular.forEach(value.provinces,function(value2){
                                        if(item1.name == value2.name){
                                            item1.selected = true;
                                        }
                                    })
                                })
                            })
                        });
                    }
                    console.log(vm.areas)
                })
            });
        }

        function arrInit(data){
            var map = {},
                provinces = [];
            for(var i = 0; i < data.length; i++){
                var ai = data[i];
                if(!map[ai.area]){
                    provinces.push({
                        area: ai.area,
                        provinces: [ai]
                    });
                    map[ai.area] = ai;
                }else{
                    for(var j = 0; j < provinces.length; j++){
                        var dj = provinces[j];
                        if(dj.area == ai.area){
                            dj.provinces.push(ai);
                            break;
                        }
                    }
                }
            }
            return provinces;
        }

        $scope.isSelected = function(province,area){
            console.log(province);
            console.log(area);
            province.selected = !province.selected;
            area.selected = area.provinces.every(function(item){return item.selected;})
        };

        $scope.isSelectedAll = function(area){
            area.selected = !area.selected;
            angular.forEach(area.provinces,function(item){
                item.selected = area.selected;
            })
        };

        vm.provinces =[];
        $scope.validate = function() {
            angular.forEach(vm.areas,function(item){
                angular.forEach(item.provinces,function(value){
                    if(value.selected){
                        vm.provinces.push(value);
                    }
                });
            });
            if(vm.provinces.length ==0 || vm.provinces == null){
                MessageService.error("请设置区域！");
                return false;
            }
            return true;
        };


        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;

            vm.areasList =[];
            for(var i=0;i<vm.areas.length;i++){
                var provinces = [];
                for(var j=0;j<vm.areas[i].provinces.length;j++){
                    if(vm.areas[i].provinces[j].selected){
                        provinces.push(vm.areas[i].provinces[j]);
                    }
                }
                if(provinces.length >0){
                    vm.areasList.push({area:vm.areas[i].area,provinces:provinces,selected:vm.areas[i].selected})
                }
            }
            console.log(vm.areasList);
            $uibModalInstance.close(vm.areasList);
        }

        function clear(){
            $uibModalInstance.dismiss();
        }

    }
})();
